import { render, staticRenderFns } from "./MessagesHolder.vue?vue&type=template&id=6e18dbcc&"
import script from "./MessagesHolder.vue?vue&type=script&lang=js&"
export * from "./MessagesHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports